<template>
	<div class="choice">
		<back-to></back-to>
		<section class="choiceDate">
			<van-calendar title="日期选择" :formatter="formatter" :poppable="false" :show-confirm="false"
				class="choiceDate-calendar" @select="select" :default-date="null" />
		</section>
		<!-- 类型和数量 -->
		<section class="choiceNum">
			<div class="choiceNum-sku">
				<h2>产品类型</h2>
				<span v-for="(item, index) in listTickets" :class="item.skuid == proTypeID?'skuActive':''"
					@click="sku(item.skuid,index)">
					<p>{{item.skuName}}</p><img v-if="item.skuid == proTypeID"
						src="https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20250924.3.png?v=2" alt="">
				</span>
			</div>
			<div class="choiceNum-num">
				<h2>购买数量</h2>
				<div class="choiceNum-num-n">
					<span>数量</span>
					<span>
						<p class="btn btn-minus" @click="sub"></p>
						<font>{{num}}</font>
						<p class="btn btn-plus" @click="add"></p>
					</span>
				</div>
			</div>
		</section>
		<!-- 底部 -->
		<section class="choiceBtn">
			<div class="choiceBtn-l">
				<p>价格:</p>
				<font>￥{{total}}</font>
			</div>
			<div class="choiceBtn-r" v-if="stock > 0" @click="goto">填写信息</div>
			<div class="choiceBtn-r" v-else style='background: #e5e4e3;'>已售罄</div>
		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	import {
		Dialog
	} from 'vant'
	export default {
		name: 'choice',
		components: {
			BackTo
		},
		data() {
			return {
				listTickets: [],
				proTypeID: 0,
				skuIndex: 0,
				num: 1,
				price: 0,
				total: 0,
				time: '',
				stock: 1,
				planid: 0
			}
		},
		created() {
			this.proTypeID = this.$route.query.proTypeID
			this.skuIndex = this.$route.query.skuIndex ? this.$route.query.skuIndex : 0
		},
		mounted() {
			this.setScheduleint()
		},
		methods: {
			goto() {
				if (this.time == '') {
					Dialog.alert({
						message: '请选择套餐日期',
					}).then(() => {});
					return false
				}

				let orderParam = {}
				orderParam.proID = this.$route.query.id
				orderParam.proName = this.listTickets[this.skuIndex].name
				orderParam.number = this.num
				orderParam.payMoney = this.total
				orderParam.skuid = this.proTypeID
				orderParam.calendarNative = this.planid
				orderParam.orderType = this.$route.query.orderType

				this.$router.push({
					path: '/order',
					query: {
						orderParam: JSON.stringify(orderParam)
					}
				})
			},
			sub() {
				if (this.num < 1) {
					this.num = 0
				} else {
					this.num = this.num - 1
					this.total = this.num * parseFloat(this.price)
				}
			},
			add() {
				this.num = this.num + 1
				this.total = this.num * parseFloat(this.price)
			},
			sku(skuid, index) {
				this.proTypeID = skuid;
				this.skuIndex = index
				var list = this.listTickets[this.skuIndex].dateTicketList
				if (list.length > 0) {
					if (this.time == '') {
						this.time = ''
						this.planid = 0
						this.price = 0
						this.total = 0
					} else {
						var data = list.filter(item => item.date == this.time)
						this.planid = data[0].id
						this.price = data[0].price
						this.total = this.num * parseFloat(this.price)
					}
				}

			},
			select(e) {
				var list = this.listTickets[this.skuIndex].dateTicketList
				var time = this.formatDateTime(e)
				var data = list.filter(item => item.date == time)
				if (data.length > 0) {
					this.time = time
					this.planid = data[0].id
					this.price = data[0].price
					this.stock = data[0].stock
					if (this.num > this.stock) {
						this.num = data[0].stock
					}
					this.total = this.num * parseFloat(this.price)
				} else {
					Dialog.alert({
						message: '暂无计划安排，请重新选择日期',
					}).then(() => {
						this.total = 0
					});

				}

			},
			// 时间格式化
			formatDateTime(timestamp) {
				var date = new Date(timestamp);
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				var minute = date.getMinutes();
				minute = minute < 10 ? ('0' + minute) : minute;
				var second = date.getSeconds();
				second = second < 10 ? ('0' + second) : second;
				// var Time = y + '-' + m + '-' + d + 'T' + h + ':' + minute + ':' + second;
				var Time = y + '-' + m + '-' + d + 'T00:00:00';
				return Time
			},
			setScheduleint() {
				this.$post(
					this.$apiList + '/NewNearTravel/GetDatePriceByID?id=' + this.$route.query.id + "&bigId=0", {}
				).then(res => {
					console.log(res)
					this.listTickets = res.result.tickets
				})
			},
			formatter(day) {
				const year = day.date.getFullYear();
				const month = day.date.getMonth() + 1;
				const date = day.date.getDate();
				console.log(this.skuIndex)
				if (this.listTickets.length > 0) {
					var list = this.listTickets[this.skuIndex].dateTicketList
					list.forEach((e, index) => {
						var myobjc = e.date.split('T')[0]
						var currentObj = new Date(Date.parse(myobjc.replace(/-/g, "/")));
						if (year === currentObj.getFullYear()) {
							if (month === (currentObj.getMonth() + 1)) {
								if (date === currentObj.getDate()) {
									day.bottomInfo = '￥' + e.price;
								}
							}
						}
					});
				}
				return day
			}

		}
	}
</script>

<style>
	.choiceDate-calendar {
		height: 890px;
	}

	.choiceDate .van-calendar__header-title {
		height: 80px;
		line-height: 80px;
		color: #000;
		font-size: 32px;
		background: #f6f6f6;
		text-align: left;
		padding-left: 32px;
		box-sizing: border-box;
	}

	.choiceDate .van-calendar__weekdays {
		background-color: #ff8a00;
		color: #fff;
	}

	.choiceDate .van-calendar__selected-day {
		background-color: rgba(255, 109, 0, .3);
		color: #ff6d00;
	}

	.choiceDate .van-calendar__bottom-info {
		color: #ff6d00;
	}

	.choiceNum {
		width: 100%;
		padding: 10px 42px;
		box-sizing: border-box;
		padding-bottom: 160px;
	}

	.choiceNum h2 {
		font-size: 33px;
		font-weight: normal;
	}

	.choiceNum-sku span {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #333;
		background: #f9f9f9;
		border-radius: 8px;
		margin: 35px 0;
		font-size: 28px;
		height: 60px;
	}

	.choiceNum-sku span p {
		padding-left: 19px;
	}

	.choiceNum-sku span img {
		width: 45px;
		height: 45px;
		margin-top: auto;
	}

	.skuActive {
		border: 1px solid #ff9240;
	}

	.skuActive p {
		color: #ff9240;
	}

	.choiceNum-num-n {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		margin-top: 40px;
	}

	.choiceNum-num-n span {
		display: flex;
		align-items: center;
	}

	.choiceNum-num-n font {
		display: inline-block;
		background: #fef6f1 no-repeat center;
		width: 84px;
		height: 45px;
		line-height: 45px;
		color: #666;
		text-align: center;
		font-size: 28px;
	}

	.btn {
		display: inline-block;
		background: #FFF no-repeat center;
		width: 64px;
		height: 45px;
		border-radius: 2px;
		box-shadow: 0 1px rgba(100, 100, 100, .1);
		color: #666;
		transition: color .2s, background-color .2s;

	}

	.btn-minus {
		background-image: linear-gradient(to top, currentColor, currentColor);
		height: 45px;
		background-size: 25px 4px;
	}

	.btn-plus {
		background-image: linear-gradient(to top, currentColor, currentColor), linear-gradient(to top, currentColor, currentColor);
		background-size: 25px 4px, 4px 25px;
	}

	.choiceBtn {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 96px;
		border-top: 1px solid #e5e4e3;
		background-color: #fff;
	}

	.choiceBtn div {
		height: 96px;
		display: flex;
		align-items: center;
	}

	.choiceBtn-r {
		width: 286px;
		background: #ff6d00;
		font-size: 36px;
		color: #fff;
		border: 0;
		justify-content: center;
	}

	.choiceBtn-l {
		color: #ff6d00;
		font-size: 48px;
		display: inline-block;
		padding-left: 28px;
		box-sizing: border-box;
	}

	.choiceBtn-l p {
		font-size: 28px;
		color: #333;
		margin-top: 12px;
		padding-right: 7px;
	}
</style>